export default __webpack_public_path__ + "static/trackrecordimg_4-ab7ed9d4099e45b457e570e1405897e0.png";